import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import { fetchThankviewEngagements } from "apps/tasks/utils/fetch-helpers";

const ThankviewSearchSummary = ({ contact }) => {
  const [count, setCount] = useState(0);
   useEffect(() => {
    const getThankviewEngagements = async (contact) => {
      try {
        const engagements = await fetchThankviewEngagements(contact.id);
        setCount(engagements.length);
      } catch (e) {
        console.error(e);
      }
    };
    getThankviewEngagements(contact);
  }, [contact]);
  return (
    <span>
      <strong>{count}</strong> engagements on <strong>All ThankView Videos</strong>
    </span>
  );
};

ThankviewSearchSummary.propTypes = {
  contact: PropTypes.object,
};

export default ThankviewSearchSummary;
